var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,-6315.27,-1010.71)"},React.createElement("g",{"transform":"matrix(1,0,0,1.6,6029.67,-25)"},React.createElement("g",{"transform":"matrix(1.20667,0,0,1.04167,281.987,641.071)"},React.createElement("path",{"d":"M10,18L14,18L14,16L10,16L10,18ZM3,6L3,8L21,8L21,6L3,6ZM6,13L18,13L18,11L6,11L6,13Z","style":{"fill":"rgb(130,115,218)","fillRule":"nonzero"}})))));
}

Filter.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 22 20","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = Filter;

Filter.default = Filter;
